import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  FormInput,
  FormGroup,
  InputGroup,
  Button
} from "shards-react";
import axios from "axios";
import { useHistory } from "react-router-dom";

import "./Register.css";

function Register() {
  const { REACT_APP_API_URL } = process.env;
  const history = useHistory();
  let intialState = {
    email: "",
    password: "",
    firstName: "",
    lastName: ""
  };
  const [user, setUser] = useState(intialState);

  const register = async () => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/admin/signup`,
        user
      );
      if (response.statusText === "ok") {
        history.push("/login");
      } else {
        alert("Something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Row className="main_row">
      <Col sm="12" md="6">
        <h4 className="header_text">Registration Form</h4>
        <Form>
          <FormGroup>
            <InputGroup className="mb-3">
              <FormInput
                placeholder="First Name"
                value={user.firstName}
                onChange={e => setUser({ ...user, firstName: e.target.value })}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <InputGroup className="mb-3">
              <FormInput
                placeholder="Last Name"
                value={user.lastName}
                onChange={e => setUser({ ...user, lastName: e.target.value })}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <InputGroup className="mb-3">
              <FormInput
                placeholder="Email"
                value={user.email}
                onChange={e => setUser({ ...user, email: e.target.value })}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <FormInput
              type="password"
              placeholder="Password"
              value={user.password}
              onChange={e => setUser({ ...user, password: e.target.value })}
            />
          </FormGroup>
          <Button theme="success" className="submit_button" onClick={register}>
            Submit
          </Button>
        </Form>
      </Col>
    </Row>
  );
}

export default Register;
